import { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import TechnicalTypeEditorForm, { FormTechnicalType } from 'src/common/forms/TechnicalTypeEditorForm';
import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';

interface Props extends Omit<DialogProps, 'title'> {
  handleClose: () => void;
  handleSave: (editedTechnicalType: FormTechnicalType, id?: string) => void;
  item?: FormTechnicalType;
  withIcon?: boolean;
}

const TechnicalTypeEditorModal = ({
  id,
  open,
  handleClose,
  handleSave,
  item,
  withIcon,
}: Props) => {
  const { t } = useTranslation();
  const title = item
    ? t('technicalTypes.editModalTitle', { name: `${item.name}` })
    : t('technicalTypes.addModalTitle');

  return (
    <EditorDialogShell
      id={id ?? 'technical-type-editor'}
      open={open}
      onClose={handleClose}
      title={title}
      maxWidth="md"
      contentSx={{ overflowX: 'hidden' }}
    >
      <TechnicalTypeEditorForm
        handleSave={handleSave}
        handleClose={handleClose}
        item={item}
        withIcon={withIcon}
      />
    </EditorDialogShell>
  );
};

export default TechnicalTypeEditorModal;
